/** A plain object, so arrays are excluded — they're walked entry by entry. */
export const isRecord = (value: unknown): value is Record<string, unknown> =>
  typeof value === 'object' && value !== null && !Array.isArray(value)
